module.exports = __webpack_public_path__ + "img/favoriten.97374875.svg";